import type React from 'react';

import { DateInput } from '../../Input/DateInput';
import { input, inputErrorLabel, inputErrorWrapper, navbar, removeInputFocusStyles } from '../util/styles';

interface SingleDatePickerNavbarProps {
  inputValue?: string;
  inputRef: (input: HTMLElement | undefined) => void;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocusInput?: () => void;
  inputError: boolean;
  noFocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string;
  hideErrorMessage?: boolean;
  name?: string;
  readOnly?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const SingleDatePickerNavbar: React.FC<SingleDatePickerNavbarProps> = ({
  inputValue,
  inputRef,
  handleFocusInput,
  handleInputChange,
  inputError,
  noFocus,
  disabled,
  placeholder,
  error,
  errorMessage,
  name,
  readOnly,
  hideErrorMessage,
}) => {
  const classes = `${input} ${noFocus && !(inputError || error) ? removeInputFocusStyles : ''}`;
  const message = errorMessage || 'Insira uma data válida';

  return (
    <div className={navbar}>
      <div className={inputErrorWrapper(noFocus)}>
        <DateInput
          className={classes}
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          inputRef={inputRef}
          onFocus={handleFocusInput}
          error={inputError || error}
          disabled={disabled}
          name={name}
          readOnly={readOnly}
        />
        {(error || inputError) && !hideErrorMessage && <span className={inputErrorLabel}>{message}</span>}
      </div>
    </div>
  );
};
